import { render, staticRenderFns } from "./Grid2.vue?vue&type=template&id=5577110c"
import script from "./Grid2.vue?vue&type=script&lang=js"
export * from "./Grid2.vue?vue&type=script&lang=js"
import style0 from "./Grid2.vue?vue&type=style&index=0&id=5577110c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports